import type { CourseType } from '@/types/course-type'
import { bff_client } from '@/lib/apiClient'

/**
 * Product detail for browser contexts — uses `bff_client` instead of server `bff`
 * (avoids importing `next/headers` from Client Components).
 */
export function getProductClient(reference: string): Promise<CourseType> {
  return bff_client
    .get(`products/${reference}`, {
      searchParams: {
        status: 'actived',
      },
    })
    .json<CourseType>()
}
